export class OrderFormMappingModal {
  imCode: string[];
  orderForm: string;
  vendorName?: string;

  constructor(imCode: string[], orderForm: string, vendorName?: string) {
    this.imCode = imCode;
    this.orderForm = orderForm;
    this.vendorName = vendorName;
  }
}
